import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";

import * as aboutActions from "../actions/about.actions";
import { AboutHttpService } from "../services/about-http.service";
import { combineLatest, map, switchMap } from "rxjs";
import { VersionService } from "../../auth/services/version-service";

@Injectable()
export class AboutEffects {
  constructor(
    private actions$: Actions,
    private aboutHttpService: AboutHttpService,
    private versionService: VersionService,
  ) {
  }

  load$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<aboutActions.Load>(aboutActions.LOAD),
      switchMap((action) => {
        const aboutInfoAndAppVersion = combineLatest([
          this.aboutHttpService.getAboutDetails(action.product),
          this.versionService.getApplicationVersion(),
        ]);
        return aboutInfoAndAppVersion.pipe(
          map(([aboutModel, versionNumber]) =>
            new aboutActions.LoadComplete(aboutModel, versionNumber)
          ),
        );
      }),
    )
  );
}
